import React, { forwardRef, ReactNode } from 'react'
import clsx from 'clsx'

// interface IconProps {
// 	name: string
// 	className?: string
// 	tagName?: string
// 	children?: ReactNode[]
// }

export const Icon: React.FC<any> = forwardRef(({
	name,
	className,
	children,
	tagName = 'i',
	...props
}, ref) => {

	return React.createElement(tagName, {
		...props,
		ref,
		className: clsx(className, 'icon', {
			[`icon:${name}`]: name,
			'icon': !name && children,
		}),
	}, children)

})
